import React from "react";

// mui components
import { Modal, Stack, Box } from "@mui/material";

// custom components
import Heading2 from "../../typography/heading-02";

// custom animations
import Lottie from "lottie-react";
import addingFileAnimation from "../../../assets/animations/adding-file.json";

// custom styles
import styles from "./index.module.scss";

export default function ProcessingModal({ open, text }) {
	return (
		<Modal
			open={open}
			aria-labelledby="processing modal"
			aria-describedby="processing modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
		>
			<Stack
				direction="column"
				justifyContent="center"
				alignItems="center"
				className={styles.modalBodyContainer}
			>
				<Box className={styles.animationContainer}>
					<Lottie animationData={addingFileAnimation} loop={true} />
				</Box>

				<Stack
					direction="column"
					alignItems="center"
					className={styles.textContainer}
				>
					<Heading2
						text="Processing..."
						extraClass={styles.processingText}
						fontType="semibold"
					/>
				</Stack>
			</Stack>
		</Modal>
	);
}
